/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldP = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M982 128q136 0 253 26t203 87 136 164 49 253q0 97-26 176t-72 141-109 108-139 76-158 45-171 15H766v573H384V128h598zm-66 807q67 0 123-13t97-45 62-81 23-124q0-72-23-121t-63-79-97-43-122-13H766v519h150z"
    }));
export default SvgBoldP;
